import styled from 'styled-components';
import { Toggle } from '@playbookux/playbook-web-core';

export const ConsentConfigToggleContainer = styled.div`
  display: flex;
  margin-top: 10px;
  margin-bottom: 25px;
`;
export const ToggleButton = styled(Toggle)``;
export const ToggleContainer = styled.div`
  margin-right: 10px;
`;
export const Blocker = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  top: -100%;
  cursor: not-allowed;
`;
export const GenericContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
